import { mountMerchantApplication } from "./bootstrap/merchant-app.js";
import { router } from "./router/vue-router.js";
import "./styles/merchant-ui.css";

mountMerchantApplication({
  rootSelector: "[data-price-rescue-merchant-ui]",
  router,
});
